var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlackLogin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.694,
    height: 23.15,
    viewBox: "0 0 24.694 23.15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "mbri-login",
    d: "M10.56,7.911,13.665,11a.806.806,0,0,1,0,1.114L10.56,15.213c-.7.694-1.781-.417-1.065-1.111l2.57-2.516L9.493,9.024c-.732-.73.444-1.735,1.068-1.111ZM8.489,10.8H.772a.772.772,0,1,0,0,1.543H8.489A.772.772,0,0,0,8.489,10.8ZM9.26,0A3.1,3.1,0,0,0,6.174,3.087V6.945a.772.772,0,0,0,1.543,0V3.087A1.523,1.523,0,0,1,9.26,1.543H21.607A1.523,1.523,0,0,1,23.15,3.087V20.063a1.523,1.523,0,0,1-1.543,1.543H9.26a1.523,1.523,0,0,1-1.543-1.543V16.2a.772.772,0,0,0-1.543,0v3.858A3.1,3.1,0,0,0,9.26,23.15H21.607a3.1,3.1,0,0,0,3.087-3.087V3.087A3.1,3.1,0,0,0,21.607,0Z",
    transform: "translate(0.001)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackLogin);
export default __webpack_public_path__ + "static/media/black_login.ac2c4a82713076fe5608879e655f2862.svg";
export { ForwardRef as ReactComponent };